import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useGetMyDetails } from '../../../redux/api/users/usersApi';
import { Paths } from '../../../shared/paths';
import Loader from '../../layout/loader/Loader';

interface IRegistrationCompletionGateProps {
  children: ReactNode;
}

const RegistrationCompletionGate = ({
  children,
}: IRegistrationCompletionGateProps) => {
  const {
    data: me,
    isLoading,
    isFetching,
    isUninitialized,
  } = useGetMyDetails();

  if ((isLoading || isFetching || isUninitialized) && !me?.id) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  if (me?.isRegistrationCompleted === false) {
    return <Navigate to={Paths.completeRegistration} replace />;
  }

  return <>{children}</>;
};

export default RegistrationCompletionGate;
